module.exports = __webpack_public_path__ + "static/media/s_ice_hockey.638585dc.mp3";